import { initHrefs, initHrefSingle } from '../wwwroot/js/_href-helper';
import { initDropdownButtons } from '../wwwroot/js/_dropdown-button-helper';
import { initDialogs } from '../wwwroot/js/_dialogs';
import { initSuccessMessages } from '../wwwroot/js/_success-messages';
import { initFilePickers } from '../wwwroot/js/_custom-file-picker';
import { initAccordions } from '../wwwroot/js/_accordions';
import { initColorInputs } from '../wwwroot/js/_color-input';
import { initAlerts } from '../wwwroot/js/_alerts';
import { initTableSort, initTableSortSingle } from '../wwwroot/js/_table-sort';

initHrefs();
initDropdownButtons()
initDialogs();
initSuccessMessages();
initFilePickers();
initAccordions();
initColorInputs();
initTableSort();
initAlerts();

const filterBars = document.querySelectorAll<HTMLElement>('.table-filter-bar');
filterBars.forEach(bar => {
    const selects = bar.querySelectorAll<HTMLElement>('multi-select');

    selects.forEach(select => {
        select.addEventListener('opened', () => {
            bar.style.zIndex = '10';
        });
        select.addEventListener('closed', () => {
            bar.style.zIndex = '';
        });
    })
});

const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
        for (let i = 0; i < mutation.addedNodes.length; i++) {
            const node = mutation.addedNodes[i];

            if (!(node instanceof HTMLElement)) continue;

            // real <table> or "fake" table (.table) carrying .table-sort
            if (node.matches('.table-sort')) {
                initTableSortSingle(<HTMLElement>node);
            }

            node.querySelectorAll('.table-sort').forEach(table => {
                initTableSortSingle(<HTMLElement>table);
            });

            // [data-href]
            if (node.matches('[data-href]')) {
                initHrefSingle(node);
            }

            node.querySelectorAll('[data-href]').forEach(elem => {
                initHrefSingle(<HTMLElement>elem);
            });
        }
    }
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});